import { setSelectedOrderIds } from '../../../State/selectedOrderIds'

export default (ids) => (dispatch) => {

  dispatch(setSelectedOrderIds(ids))

}
